'use client';

import { ReactNode } from 'react';
import Accordion from '.';

export default function AccordionWrapper({
  children,
  defaultOpen = false,
}: {
  children: ReactNode;
  defaultOpen?: boolean;
}) {
  return (
    <Accordion defaultOpen={defaultOpen}>
      <Accordion.Item>{children}</Accordion.Item>
    </Accordion>
  );
}
